const state = {
  isShowMaterial: false,
}

const mutations = {
  show(state) {
    document.body.style.overflow = 'hidden'
    state.isShowMaterial = true

  },
  hide(state) {
    document.body.style.overflow = 'auto'
    state.isShowMaterial = false
  },
}

const actions = {


}

const getters = {
  getIsShowMaterial: state => ()=> state.isShowMaterial
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
